import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Firebase web config is public by design; access is enforced by security rules.
const firebaseConfig = {
  apiKey: 'AIzaSyDjtz_fTKHJpNexzAwt2wxskQsyy4dGtmg',
  authDomain: 'wave-c7b1a.firebaseapp.com',
  projectId: 'wave-c7b1a',
  storageBucket: 'wave-c7b1a.firebasestorage.app',
  messagingSenderId: '971727247298',
  appId: '1:971727247298:web:a2fd7f39b4454b0534685b',
  measurementId: 'G-YLNF2VW1EE'
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// Local emulators are opt-in: set REACT_APP_USE_EMULATORS=true (web) or
// globalThis.WAVE_USE_EMULATORS = true before importing (mobile/tests).
const useEmulators =
  (typeof process !== 'undefined' && process.env && process.env.REACT_APP_USE_EMULATORS === 'true') ||
  (typeof globalThis !== 'undefined' && globalThis.WAVE_USE_EMULATORS === true);

if (useEmulators) {
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectStorageEmulator(storage, '127.0.0.1', 9199);
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
}

export { db, auth, storage, functions, firebaseConfig };
